module.exports = __webpack_public_path__ + "img/header-entry.94059015.png";